import { gql } from "lib/apolloClient";

export const curriculumProgramFragment = {
  curriculumProgramBasicDetails: gql`
    fragment curriculumProgramBasicDetailsItem on CurriculumProgram {
      id
      type
      label
      acronym
      nodeInterfaceType
      programType
    }
  `,
};
